import React from 'react';
import { Link } from 'react-router-dom';
import { FieldGroup } from '@ver-uds/react';
import Section from './Section';

const Contacts = (): JSX.Element => {
  return (
    <Section title="Points of Contact" data-testid="points-of-contact">
      <FieldGroup className="grid-row grid-gap margin-bottom-1">
        <FieldGroup.Field className="grid-col-12" name="Total Points of Contact">
          {/* this static value will be updated when contacts api is implmented  */}
          123
        </FieldGroup.Field>
      </FieldGroup>

      {/* the line below will be removed once link becomes active */}
      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
      <Link to="#" className="usa-button usa-button--outline">
        Edit Points of Contact
      </Link>
    </Section>
  );
};

export default Contacts;
